<template>
  <svg
    class="fa-icon"
    :viewBox="viewBox"
    :width="sizePx"
    :height="sizePx"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path v-for="(d, i) in paths" :key="i" :d="d" />
  </svg>
</template>

<script>
/**
 * Font Awesome 图标渲染组件（按需引入版）。
 *
 * 用法：
 *   import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart'
 *   <FaIcon :icon="faHeart" :size="16" />
 *
 * 说明：项目装了 @fortawesome/free-*-svg-icons，但没装 @fortawesome/vue-fontawesome，
 * 所以这里直接读图标定义里的 path 数据渲染成内联 svg：
 *  - 只打包真正 import 进来的图标（走子路径引入，不会把 2000+ 个图标全打进包里）
 *  - 颜色跟随 currentColor，尺寸由 size 控制，和文字按钮的样式体系天然兼容
 */
export default {
  name: 'FaIcon',
  props: {
    icon: {
      type: Object,
      required: true
    },
    size: {
      type: [Number, String],
      default: 16
    }
  },
  computed: {
    meta() {
      return (this.icon && this.icon.icon) || []
    },
    viewBox() {
      return `0 0 ${this.meta[0] || 512} ${this.meta[1] || 512}`
    },
    paths() {
      const raw = this.meta[4]
      if (!raw) return []
      // 少数图标（如 faB / faG）的 path 数据是数组，需要渲染多个 <path>
      return Array.isArray(raw) ? raw : [raw]
    },
    sizePx() {
      return typeof this.size === 'number' ? `${this.size}px` : this.size
    }
  }
}
</script>

<style scoped>
.fa-icon {
  display: inline-block;
  vertical-align: -0.125em;
  flex: none;
  pointer-events: none;
}
</style>
